function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 6.00011V12.0001L13.9999 13.0001M12.3369 21.9941C10.2935 22.0629 8.27805 21.5036 6.56224 20.3917C4.84642 19.2799 3.51267 17.6687 2.74069 15.7755C1.96871 13.8822 1.79561 11.7979 2.24472 9.8032C2.69383 7.80855 3.74355 5.99949 5.25245 4.61979C6.76135 3.2401 8.6569 2.35608 10.6837 2.08684C12.7105 1.81761 14.7711 2.17611 16.5878 3.11403C18.4046 4.05196 19.8902 5.52423 20.8445 7.33246C21.7988 9.14069 22.1758 11.198 21.9249 13.2271M13.9999 18.0001L17.9999 22.0001M17.9999 22.0001L21.9999 18.0001M17.9999 22.0001V14.0001",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgExports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExports);
export default __webpack_public_path__ + "static/media/exports.2e90bed0.svg";
export { ForwardRef as ReactComponent };